import type { JSX } from 'solid-js';
import type { Tone } from '~/types/game';

interface BadgeProps {
  tone?: Tone | '';
  children: JSX.Element;
}

export function Badge(props: BadgeProps) {
  return <span class={`badge ${props.tone ?? ''}`}>{props.children}</span>;
}
